<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
      </div>
      <v-card-text class="editor-content">
        <section class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8"><v-text-field v-model="fields.title" label="Name" hide-details/></v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </section>
        <SectionSettingsContainerFuild
          class="mb-4"
          :settings="fields.settings"
          :container-page="fields.containerPage"
          :use-background-mobile="true"
          :show-container-page="false"
        />
        <section class="mb-4">
          <label class="label-input">Header</label>
          <div class="group-item">
            <p class="field-label">Title</p>
            <ckeditor :editor="editor" v-model="fields.header.title" :config="editorConfig" />
            <p class="field-label mt-4">Description</p>
            <ckeditor :editor="editor" v-model="fields.header.description" :config="editorConfig" />
            <p class="field-label mt-4">Decoration</p>
            <UploadImage
              :image="{ imageSrc: fields.header.decor }"
              height="100"
              type-upload="image"
              @callback="handleUploadDecor"
              @callbackDelete="handleRemoveDecor"
            />
          </div>
        </section>
        <section class="mb-4">
          <label class="label-input">Made in Germany logo</label>
          <div class="group-item">
            <UploadImage
              :image="{ imageSrc: fields.content.logo }"
              height="160"
              type-upload="image"
              @callback="handleUploadLogo"
              @callbackDelete="handleRemoveLogo"
            />
            <small class="d-block mt-2 grey--text">This logo is hidden on mobile.</small>
          </div>
        </section>
        <section class="mb-4">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Benefits</label>
            <v-btn small text color="primary" @click="handleAddItem"> <v-icon small>mdi-plus</v-icon>Add item </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, index) in fields.items" :key="index">
              <v-expansion-panel-header>
                <span>{{ item.text || 'Item ' + (index + 1) }}</span>
                <template #actions>
                  <v-btn icon @click.stop="handleRemoveItem(index)">
                    <v-icon color="error">mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <p class="field-label">Icon</p>
                <UploadImage
                  :image="{ imageSrc: item.icon }"
                  height="100"
                  type-upload="image"
                  @callback="obj => handleUploadItemIcon(obj, index)"
                  @callbackDelete="() => handleRemoveItemIcon(index)"
                />
                <v-text-field v-model="item.text" class="mt-4" label="Text" hide-details />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </section>
        <ButtonPrimary :button="fields.button" :show-icon-prefix="false" :show-sub-btn="false" />
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions>
          <v-spacer />
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update.js';
import ButtonPrimary from './common/button-primary.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

const benefitIcon = 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0bff1132bcad8dfe330f7.png?w=500';
const defaultItem = text => ({ icon: benefitIcon, text });

export default {
  name: 'FurnitureshopBanner02',
  components: { UploadImage, ButtonPrimary, SectionSettingsContainerFuild },
  props: { sectionEditor: { type: Object, required: true } },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Furnitureshop banner 02',
        enableAnchor: false,
        settings: {
          paddingTop: false,
          paddingBottom: false,
          backgroundColor: '#05090D',
          textColor: '#FFFFFF',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
          useBackgroundMobile: true,
          backgroundImageMobile: '',
        },
        containerPage: { enableStyle: false, background: '#FFFFFF' },
        header: { title: '', description: '', decor: '' },
        content: { logo: '' },
        items: [defaultItem('Scratch Resistant'), defaultItem('Swirl Defense'), defaultItem('Impact Shield')],
        button: {
          show: true,
          backgroundColor: '#FF8100',
          color: '#FFFFFF',
          radius: 4,
          text: 'BUY NOW',
          link: '#',
          iconPrefix: { show: false, src: '' },
          iconSuffix: { show: true, src: '' },
          subBtn: { show: false, text: '' },
        },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(value) {
        if (value?.sectionExtract) this.applyExtract(value.sectionExtract);
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        header: { ...this.fields.header, ...(extract.header || {}) },
        content: { ...this.fields.content, ...(extract.content || {}) },
        items: Array.isArray(extract.items) ? extract.items : this.fields.items,
        button: {
          ...this.fields.button,
          ...(extract.button || {}),
          iconPrefix: { ...this.fields.button.iconPrefix, ...((extract.button || {}).iconPrefix || {}) },
          iconSuffix: { ...this.fields.button.iconSuffix, ...((extract.button || {}).iconSuffix || {}) },
          subBtn: { ...this.fields.button.subBtn, ...((extract.button || {}).subBtn || {}) },
        },
      };
    },
    handleUploadDecor(obj) {
      this.fields.header.decor = obj?.imageSrc || '';
    },
    handleRemoveDecor() {
      this.fields.header.decor = '';
    },
    handleUploadLogo(obj) {
      this.fields.content.logo = obj?.imageSrc || '';
    },
    handleRemoveLogo() {
      this.fields.content.logo = '';
    },
    handleAddItem() {
      this.fields.items.push(defaultItem('Benefit'));
    },
    handleRemoveItem(index) {
      this.fields.items.splice(index, 1);
    },
    handleUploadItemIcon(obj, index) {
      if (this.fields.items[index]) this.$set(this.fields.items[index], 'icon', obj?.imageSrc || '');
    },
    handleRemoveItemIcon(index) {
      if (this.fields.items[index]) this.$set(this.fields.items[index], 'icon', '');
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const html = updateHtmlFromData.sectionFurnitureshopBanner02(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', { ...this.sectionEditor.section, title: this.fields.title, html });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.editor-content {
  max-height: 70vh;
  overflow-y: auto;
}
.group-item {
  padding: 15px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
}
::v-deep .ck-editor__editable_inline {
  min-height: 100px;
}
</style>
